<template>
  <!-- 发票管理 历史发票 开具发票 -->
  <div>
    <dialogModel
      title="代开发票"
      width="1200px"
      :visible.sync="dialogIssue"
      @handleClose="handleIssue"
      @handleOk="handleVerifyIssue"
    >
      <div class="main-body">
        <div class="Select-Con">
          <div
            v-for="(item, index) in SwitchArr"
            :key="index"
            class="Options"
            :class="Switch == item.id ? 'Select' : ''"
            @click="handelSwitch(item.id)"
          >
            {{ item.name }}
          </div>
        </div>
        <el-form
          :model="from"
          :rules="rules"
          ref="ruleForm"
          label-width="148px"
          class="demo-ruleForm invoice-info-form"
        >
          <div class="section-row">
            <div class="section-block section-buyer">
              <div class="section-title">购买方信息</div>
              <div v-if="Switch == 1">
                <el-form-item label="购买方：" prop="Purchaser" :required="true">
                  <el-select
                    v-model="from.Purchaser"
                    placeholder="请选择购买方"
                    @change="handelChange"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.companyName"
                      :label="item.companyName"
                      :value="item.companyName"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  label="统一社会信用代码："
                  prop="PurchaserCode"
                  :required="true"
                >
                  <el-input
                    v-model="from.PurchaserCode"
                    placeholder="请先选择企业"
                    disabled
                    maxlength="30"
                  ></el-input>
                </el-form-item>

                <el-form-item
                  label="联系电话："
                  prop="PurchaserPhone"
                  :required="true"
                >
                  <el-input
                    maxlength="30"
                    v-model="from.PurchaserPhone"
                    placeholder="请输入联系电话"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="开户银行名称："
                  prop="PurchaseBankName"
                  :required="false"
                >
                  <el-input
                    v-model="from.PurchaseBankName"
                    placeholder="请先选择企业"
                    disabled
                    maxlength="30"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="开户账号："
                  prop="PurchaseAccount"
                  :required="false"
                >
                  <el-input
                    v-model="from.PurchaseAccount"
                    placeholder="请先选择企业"
                    disabled
                    maxlength="30"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="地址："
                  prop="PurchaseAddress"
                  :required="true"
                >
                  <el-input
                    v-model="from.PurchaseAddress"
                    placeholder="请先选择企业"
                    disabled
                    maxlength="30"
                  ></el-input>
                </el-form-item>

                <el-form-item label="是否展示：" required>
                  <el-radio-group v-model="from.PurchaseShowHide">
                    <el-radio
                      v-for="item in ShowHideArr"
                      :key="'buy-' + item.id"
                      :label="item.id"
                      >{{ item.name }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <div class="Reminder">
                  (用于发票展示信息，包含开户银行名称、开户账号、住所 )
                </div>
              </div>

              <div v-if="Switch == 0">
                <el-form-item label="购买方：" prop="Purchaser" :required="true">
                  <el-input
                    maxlength="30"
                    v-model="from.Purchaser"
                    placeholder="请输入购买方"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="身份证："
                  prop="PurchaserCode"
                  :required="true"
                >
                  <el-input
                    maxlength="30"
                    v-model="from.PurchaserCode"
                    placeholder="请输入身份证"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="联系电话："
                  prop="PurchaserPhone"
                  :required="true"
                >
                  <el-input
                    maxlength="30"
                    v-model="from.PurchaserPhone"
                    placeholder="请输入联系电话"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="开户银行名称："
                  prop="PurchaseBankName"
                  :required="false"
                >
                  <el-input
                    maxlength="30"
                    v-model="from.PurchaseBankName"
                    placeholder="请输入开户银行名称"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="开户账号："
                  prop="PurchaseAccount"
                  :required="false"
                >
                  <el-input
                    maxlength="30"
                    v-model="from.PurchaseAccount"
                    placeholder="请输入开户账号"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="地址："
                  prop="PurchaseAddress"
                  :required="true"
                >
                  <el-input
                    maxlength="30"
                    v-model="from.PurchaseAddress"
                    placeholder="请输入地址"
                  ></el-input>
                </el-form-item>
                <el-form-item label="是否展示：" required>
                  <el-radio-group v-model="from.PurchaseShowHide">
                    <el-radio
                      v-for="item in ShowHideArr"
                      :key="'buy0-' + item.id"
                      :label="item.id"
                      >{{ item.name }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <div class="Reminder">
                  (用于发票展示信息，包含开户银行名称、开户账号、住所 )
                </div>
              </div>
            </div>

            <div class="section-block section-seller">
              <div class="section-title">销售方信息</div>
              <el-form-item label="销售方：" required>
                <el-input
                  :value="seller.sellerName"
                  disabled
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item label="统一社会信用代码：" required>
                <el-input
                  :value="seller.sellerCreditCode"
                  disabled
                  maxlength="30"
                ></el-input>
              </el-form-item>
              <el-form-item label="法人(负责人)：" required>
                <el-input
                  :value="seller.sellerLegalPerson"
                  disabled
                  maxlength="30"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="企业类型："
                prop="EnterpriseType"
                :required="true"
              >
                <el-radio-group
                  v-model="from.EnterpriseType"
                  :disabled="!EnterpriseIsItOptional"
                  @change="
                    companyInvoiceCalculatePrice();
                    $refs.ruleForm.validateField('EnterpriseType');
                  "
                >
                  <el-radio
                    v-for="item in Arr"
                    :key="'et-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>

              <el-form-item
                label="纳税类型："
                prop="PayTaxesType"
                :required="true"
              >
                <el-radio-group
                  v-model="from.PayTaxesType"
                  :disabled="!PayTaxesIsItOptional"
                  @change="
                    companyInvoiceCalculatePrice();
                    $refs.ruleForm.validateField('PayTaxesType');
                  "
                >
                  <el-radio
                    v-for="item in Arr1"
                    :key="'pt-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>

              <el-form-item label="开户银行：" prop="bank" :required="false">
                <el-input
                  maxlength="30"
                  v-model="from.bank"
                  placeholder="请输入开户银行"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="开户账号："
                prop="AccountNumber"
                :required="false"
              >
                <el-input
                  maxlength="30"
                  v-model="from.AccountNumber"
                  placeholder="请输入开户账号"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="住所："
                prop="address"
                :required="true"
              >
                <el-input
                  maxlength="30"
                  v-model="from.address"
                  placeholder="请输入住所"
                ></el-input>
              </el-form-item>
              <el-form-item label="联系电话：" prop="phone" :required="true">
                <el-input
                  maxlength="30"
                  v-model="from.phone"
                  placeholder="请输入联系电话"
                ></el-input>
              </el-form-item>
              <el-form-item label="是否展示：" required>
                <el-radio-group v-model="from.SalesShowHide">
                  <el-radio
                    v-for="item in ShowHideArr"
                    :key="'sell-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <div class="Reminder">
                (用于发票展示信息，包含开户银行名称、开户账号、住所 )
              </div>
            </div>
          </div>

          <div class="section-block section-service">
            <div class="section-title">开票信息</div>
            <div class="Instruction">
              <el-form-item label="服务信息：" prop="Message" :required="true">
                <el-input
                  type="textarea"
                  class="textarea-lg"
                  placeholder="请输入至少10个字的内容"
                  v-model="from.Message"
                  :rows="5"
                  maxlength="1500"
                  show-word-limit
                  resize="none"
                >
                </el-input>
              </el-form-item>
            </div>

            <div class="invoice-meta-row">
              <el-form-item label="开票数量：" class="meta-item meta-quantity">
                <span class="quantity-text">{{ from.quantity }}张</span>
              </el-form-item>
              <el-form-item
                label="发票类型："
                prop="nature"
                :required="true"
                class="meta-item meta-nature"
              >
                <el-radio-group
                  v-model="from.nature"
                  @change="
                    companyInvoiceCalculatePrice();
                    $refs.ruleForm.validateField('nature');
                  "
                >
                  <el-radio
                    v-for="item in radioList1"
                    :key="'nature-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
              <el-form-item
                label="开票格式："
                prop="format"
                :required="true"
                class="meta-item meta-format"
              >
                <el-radio-group
                  v-model="from.format"
                  @change="
                    companyInvoiceCalculatePrice();
                    $refs.ruleForm.validateField('format');
                  "
                >
                  <el-radio
                    v-for="item in radioList"
                    :key="'fmt-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </div>

            <div class="invoice-meta-row invoice-send-row">
              <el-form-item
                label="发送方式："
                prop="SendingMode"
                :required="true"
                class="meta-item meta-send"
              >
                <el-radio-group
                  v-model="from.SendingMode"
                  @change="companyInvoiceCalculatePrice()"
                >
                  <el-radio
                    v-for="item in radioList2"
                    :key="'send-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>

              <el-form-item
                label="需消耗："
                prop="numBean"
                :required="true"
                class="meta-item meta-consume"
              >
                <div class="consume-text">
                  {{ from.numBean }}{{ from.numBean != "" ? "发票豆" : "" }}
                </div>
              </el-form-item>
            </div>

            <el-form-item
              label=" "
              prop="mailbox"
              :required="true"
              v-if="from.SendingMode == 2"
            >
              <el-input
                class="mailbox"
                v-model="from.mailbox"
                placeholder="请输入邮箱地址"
                maxlength="30"
              ></el-input>
            </el-form-item>

            <el-form-item label="备注：">
              <el-input
                type="textarea"
                class="textarea-lg"
                placeholder="请填写备注，若被列入风险纳税人，请及时说明情况，若没有说明情况，自身承担风险"
                v-model="from.Note"
                :rows="5"
                maxlength="1500"
                show-word-limit
                resize="none"
              >
              </el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </dialogModel>
    <!-- 支付密码验证 -->
    <VerificationPwd
      :VisiblePwd="VisiblePwd"
      @handleClosePwd="VisiblePwd = false"
      @handleUnderstandPwd="handleUnderstandPwd"
    ></VerificationPwd>
  </div>
</template>

<script>
import VerificationPwd from "../../Enterprise/Bookkeeping/components/IndexCom/VerificationPwd.vue"; //支付密码验证
import {
  companyInvoiceCalculatePrice, //计算代开发票需要消耗的发票豆
  companyInvoiceCalculatePriceColl,
  pay, //支付接口
} from "../../../../../../assets/api/Agency/Enterprise";

export default {
  props: {
    dialogIssue: {},
    seller: {}, //销售方信息
    options: {}, //公司选择
    row: {},
  },
  components: { VerificationPwd },
  data() {
    return {
      from: {
        Purchaser: "", //购买方
        PurchaserId: "", // 购买方id
        PurchaserName: "", //购买方法人
        PurchaserCode: "", //购买方统一代码
        PurchaserPhone: "", //购买方联系电话
        customerCompanyType: "", //购买方企业类型
        PurchaseBankName: "", //购买方开户银行名称
        PurchaseAccount: "", //购买方开户账号
        PurchaseAddress: "", //购买方地址

        EnterpriseType: null, //企业类型
        PayTaxesType: null, //纳税类型
        bank: "", //开户行
        AccountNumber: "", //基本开户账号
        address: "", //住所
        phone: "", //固定电话
        PurchaseShowHide: 1, //购买方信息展示/隐藏
        SalesShowHide: 1, //销售方信息展示/隐藏
        Message: "", //服务信息
        quantity: "1", //开票数量
        nature: "", //发票类型 0普票1专票
        format: "", // 开票格式
        SendingMode: "", // 发送方式
        mailbox: "", //邮箱地址
        Note: "", //备注
        numBean: "", //发票豆
      }, //填写的内容
      rules: {
        // 规则未完善
        Purchaser: [
          {
            required: true,
            message: "购买方不能为空",
            trigger: ["blur", "change"],
          },
        ],
        PurchaserCode: [
          {
            required: true,
            message: "统一社会信用代码不能为空",
            trigger: ["blur", "change"],
          },
        ],
        IdentityCard: [
          {
            required: true,
            message: "身份证号码不能为空",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的身份证号码",
            trigger: ["blur", "change"],
            pattern:
              /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
          },
        ],
        PurchaserPhone: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的手机号码",
            trigger: ["blur", "change"],
            pattern: /^\s*1[3-9]\d{9}\s*$/,
          },
        ],
        // PurchaseBankName: [
        //   {
        //     required: true,
        //     message: "购买方开户银行名称不能为空",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        PurchaseAccount: [
          // {
          //   required: true,
          //   message: "购买方开户行账号不能为空",
          //   trigger: ["blur", "change"],
          // },
          {
            pattern: /^\d{16,22}$/, // 替换成你需要的正则版本
            message: "开户账号需为16-22位纯数字",
            trigger: ["blur", "change"],
          },
        ],
        PurchaseAddress: [
          {
            required: true,
            message: "购买方地址不能为空",
            trigger: ["blur", "change"],
          },
        ],
        EnterpriseType: [
          {
            required: true,
            message: "请选择企业类型",
            trigger: ["blur", "change"],
          },
        ],
        PayTaxesType: [
          {
            required: true,
            message: "请选择纳税类型",
            trigger: ["blur", "change"],
          },
        ],
        // bank: [
        //   {
        //     required: true,
        //     message: "开户银行不能为空",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // AccountNumber: [
        //   {
        //     required: true,
        //     message: "开户账号不能为空",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        AccountNumber: [
          // {
          //   required: true,
          //   message: "开户账号不能为空",
          //   trigger: ["blur", "change"],
          // },
          {
            pattern: /^\d{16,22}$/, // 替换成你需要的正则版本
            message: "开户账号需为16-22位纯数字",
            trigger: ["blur", "change"],
          },
        ],
        address: [
          {
            required: true,
            message: "地址不能为空",
            trigger: ["blur", "change"],
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号码",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的手机号码",
            trigger: ["blur", "change"],
            pattern: /^\s*1[3-9]\d{9}\s*$/,
          },
        ],
        Message: [
          {
            min: 10,
            required: true,
            message: "请输入至少10字的服务信息",
            trigger: ["blur", "change"],
          },
        ],
        nature: [
          {
            required: true,
            message: "请选择发票类型",
            trigger: ["blur", "change"],
          },
        ],
        format: [
          {
            required: true,
            message: "请选择开票格式",
            trigger: ["blur", "change"],
          },
        ],
        SendingMode: [
          { required: true, message: " ", trigger: ["blur", "change"] },
        ],
        mailbox: [
          {
            required: true,
            message: "请输入邮箱地址",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          },
        ],
        numBean: [
          {
            required: true,
            message: "需消耗发票豆数量计算失败",
            trigger: ["blur", "change"],
          },
        ],
      },
      Arr: [
        { id: 0, name: "有限公司" },
        { id: 1, name: "个体户" },
        { id: 2, name: "子公司" },
        { id: 3, name: "分公司" },
        { id: 4, name: "其他" },
      ], //企业类型
      Arr1: [
        { id: 0, name: "小规模纳税人" },
        { id: 1, name: "一般纳税人" },
      ], //纳税类型
      radioList1: [
        { name: "普票", id: "0" },
        { name: "专票", id: "1" },
      ], // 发票类型：普票/专票
      radioList: [
        { name: "PDF", id: "0" },
        { name: "JPG", id: "1" },
        { name: "OFD", id: "2" },
        { name: "XML", id: "3" },
      ], // 选择开票格式
      radioList2: [
        { name: "邮箱", id: 2 },
        { name: "企业微信", id: 3 },
      ], // 选择发送方式
      ShowHideArr: [
        { name: "展示", id: 1 },
        { name: "隐藏", id: 0 },
      ], //是否展示

      SwitchArr: [
        { id: 1, name: "开给企业" },
        { id: 0, name: "开给自然人" },
      ], //
      Switch: 1,
      VisiblePwd: false, //支付密码验证
      EnterpriseIsItOptional: true, //企业类型是否可选
      PayTaxesIsItOptional: true, //纳税类型是否可选
    };
  },
  watch: {
    Switch: {
      handler(newSs, old) {
        // 清空from中某些数据的值（销售方信息不用清除）
      },
      immediate: false,
    },
    // // 监听
    dialogIssue: {
      handler(newSs, old) {
        if (newSs == true) {
          console.log(this.row, "回显");
          this.Switch =
            this.row.headType !== undefined && this.row.headType !== null
              ? Number(this.row.headType)
              : 1;
          this.from.Purchaser = this.row.customerName; //名称
          this.from.PurchaserCode = this.row.customerCreditCode; //信用代码
          this.from.PurchaserPhone = this.row.customerPhone; //手机号
          this.from.customerCompanyType = this.row.customerCompanyType; //企业类型
          this.from.PurchaseBankName = this.row.customerBankName; //银行
          this.from.PurchaseAccount = this.row.customerBankAccount; //账号
          this.from.PurchaseAddress = this.row.customerCompanyAddress; //地址
          this.from.PurchaseShowHide =
            this.row.showCustomerInfo !== undefined &&
            this.row.showCustomerInfo !== null &&
            this.row.showCustomerInfo !== ""
              ? Number(this.row.showCustomerInfo)
              : 1;
          this.from.SalesShowHide =
            this.row.showSellerInfo !== undefined &&
            this.row.showSellerInfo !== null &&
            this.row.showSellerInfo !== ""
              ? Number(this.row.showSellerInfo)
              : 1;
          this.from.Message = this.row.businessInfo; //服务信息

          // 单选 label 为字符串，接口多为数字，需统一类型才能回显选中
          this.from.nature =
            this.row.invoiceAttr !== undefined &&
            this.row.invoiceAttr !== null &&
            this.row.invoiceAttr !== ""
              ? String(this.row.invoiceAttr)
              : "";
          this.from.format =
            this.row.invoiceFormat !== undefined &&
            this.row.invoiceFormat !== null &&
            this.row.invoiceFormat !== ""
              ? String(this.row.invoiceFormat)
              : "";
          this.from.SendingMode =
            this.row.sendType !== undefined &&
            this.row.sendType !== null &&
            this.row.sendType !== ""
              ? Number(this.row.sendType)
              : 2;
          this.from.mailbox = this.row.mail; //邮箱地址
          this.from.Note = this.row.remark; //备注

          setTimeout(() => {
            console.log(this.seller, "this.seller");
            if (
              this.seller.companyType !== null &&
              this.seller.companyType !== ""
            ) {
              // 自动选中企业类型，不可在修改
              this.EnterpriseIsItOptional = false;
            }
            if (this.seller.taxType !== null && this.seller.taxType !== "") {
              // 自动选中纳税类型，不可在修改
              this.PayTaxesIsItOptional = false;
            }
            this.from.EnterpriseType = this.seller.companyType;
            this.from.PayTaxesType = this.seller.taxType;
            this.from.address = this.seller.sellerCompanyAddress;
            this.from.phone = this.seller.sellerPhone;
            this.companyInvoiceCalculatePrice();
          }, 500);
        } else {
          this.from = {
            Purchaser: "", //购买方
            PurchaserId: "", // 购买方id
            PurchaserName: "", //购买方法人
            PurchaserCode: "", //购买方统一代码
            IdentityCard: "", //身份证
            PurchaserPhone: "", //购买方联系电话
            customerCompanyType: "", //购买方企业类型
            PurchaseBankName: "", //购买方开户银行名称
            PurchaseAccount: "", //购买方开户账号
            PurchaseAddress: "", //购买方地址

            EnterpriseType: null, //企业类型
            PayTaxesType: null, //纳税类型
            bank: "", //开户行
            AccountNumber: "", //基本开户账号
            address: "", //住所
            phone: "", //固定电话
            PurchaseShowHide: 0, //购买方信息展示/隐藏
            SalesShowHide: 0, //销售方信息展示/隐藏
            Message: "", //服务信息
            quantity: "1", //开票数量
            nature: "", //发票类型 0普票1专票
            format: "", // 开票格式
            SendingMode: 2, // 发送方式
            mailbox: "", //邮箱地址
            Note: "", //备注

            numBean: "",
          }; //填写的内容
          this.EnterpriseIsItOptional = true;
          this.PayTaxesIsItOptional = true;
          setTimeout(() => {
            this.$refs.ruleForm.clearValidate();
          }, 500);
        }
      },
      immediate: false,
    },

    // // 监听 服务信息
    "from.Message": {
      handler(newSs, old) {
        this.companyInvoiceCalculatePrice();
      },
      immediate: false,
    },
  },
  computed: {},
  created() {},
  destroyed() {},
  methods: {
    handelSwitch(item) {
      this.from.Purchaser = ""; //购买方
      this.from.PurchaserId = ""; // 购买方id
      this.from.PurchaserName = ""; //购买方法人
      this.from.PurchaserCode = ""; //购买方统一代码
      this.from.IdentityCard = ""; //身份证
      this.from.PurchaserPhone = ""; //购买方联系电话
      this.from.customerCompanyType = ""; //购买方企业类型
      this.from.PurchaseBankName = ""; //购买方开户银行名称
      this.from.PurchaseAccount = ""; //购买方开户账号
      this.from.PurchaseAddress = ""; //购买方地址

      // EnterpriseType: null //企业类型
      // PayTaxesType: null //纳税类型
      this.from.bank = ""; //开户行
      this.from.AccountNumber = ""; //基本开户账号
      // address: "" //住所
      // phone: "" //固定电话
      this.from.PurchaseShowHide = 0; //购买方信息展示/隐藏
      this.from.SalesShowHide = 0; //销售方信息展示/隐藏
      this.from.Message = ""; //服务信息
      this.from.quantity = "1"; //开票数量
      this.from.nature = ""; //发票类型 0普票1专票
      this.from.format = ""; // 开票格式
      this.from.SendingMode = 2; // 发送方式
      this.from.mailbox = ""; //邮箱地址
      this.from.Note = ""; //备注

      this.from.numBean = "";

      setTimeout(() => {
        this.$refs.ruleForm.clearValidate();
      }, 100);
      this.Switch = item;
    },
    //选择购买方
    handelChange(val) {
      for (var i in this.options) {
        if (this.options[i].companyName == val) {
          this.from.PurchaserCode = this.options[i].customerCreditCode;
          this.from.PurchaserPhone = this.options[i].phone;
          this.from.PurchaserId = this.options[i].id;
          this.from.PurchaserName = this.options[i].legalPerson;
          this.from.customerCompanyType = this.options[i].customerCompanyType;
          this.from.PurchaseBankName = this.options[i].customerBankName;
          this.from.PurchaseAccount = this.options[i].customerBankAccount;
          this.from.PurchaseAddress = this.options[i].customerCompanyAddress;
          this.$refs.ruleForm.clearValidate();
        }
      }
    },
    //计算代开发票需要消耗的发票豆
    companyInvoiceCalculatePrice() {
      console.log(
        "11111111111",
        this.from.EnterpriseType,
        this.from.PayTaxesType,
        this.from.Message,
        this.from.quantity,
        this.from.nature,
        this.from.format,
        this.from.SendingMode
      );
      if (
        this.from.EnterpriseType !== "" &&
        this.from.EnterpriseType != null &&
        this.from.PayTaxesType !== "" &&
        this.from.PayTaxesType != null &&
        this.from.Message !== "" &&
        this.from.Message != null &&
        this.from.quantity !== "" &&
        this.from.quantity != null &&
        this.from.nature !== "" &&
        this.from.nature != null &&
        this.from.format !== "" &&
        this.from.format != null &&
        this.from.SendingMode !== "" &&
        this.from.SendingMode != null
      ) {
        console.log("22222");
        var data = {
          data: {
            companyType: this.from.EnterpriseType, //企业类型
            taxType: this.from.PayTaxesType, //纳税人类型
            headType: this.Switch, //0自然人  1企业
            itemCalculateList:
              this.Switch == 1
                ? [
                    {
                      invoiceQuantity: this.from.quantity, //开票数量
                      invoiceAttr: this.from.nature, //发票类型 0普票1专票
                      businessInfo: this.from.Message, //服务信息
                      invoiceFormat: this.from.format, //发票格式
                      sendType: this.from.SendingMode, //发送方式
                      mail: this.from.mailbox, //邮箱
                      remark: this.from.Note, //备注
                    },
                  ]
                : [
                    {
                      invoiceQuantity: this.from.quantity, //发票数量
                      invoiceAttr: this.from.nature, //发票类型 0普票1专票
                      businessInfo: this.from.Message, //服务信息
                      invoiceFormat: this.from.format, //发票格式
                      sendType: this.from.SendingMode, //发送方式
                      mail: this.from.mailbox, //邮箱
                      remark: this.from.Note, //备注
                      customerName: this.from.Purchaser, //姓名
                      customerCreditCode: this.from.PurchaserCode, //身份证号
                      customerPhone: this.from.PurchaserPhone, //手机号
                      customerBankName: this.from.PurchaseBankName, //开户行
                      customerBankAccount: this.from.PurchaseAccount, //账户
                      customerCompanyAddress: this.from.PurchaseAddress, //地址
                      showCustomerInfo: this.from.PurchaseShowHide, //是否展示购买方信息
                    },
                  ], //服务信息
          },
        };
        companyInvoiceCalculatePrice(data).then((res) => {
          if (res.code == 0) {
            this.from.numBean = res.data;
            this.$refs.ruleForm.validateField("numBean");
          }
        });
      }
    },
    // 单选发送方式
    handelSend(item) {
      this.from.SendingMode = item.id;
    },

    //单选 发票类型（普票/专票）
    handelSingleChoice(item) {
      this.from.nature = item.id;
    },
    // 单选 开票格式
    handelFormat(item) {
      this.from.format = item.id;
    },
    // 取消
    handleIssue() {
      this.$emit("handleIssue", this.type);
    },
    // 数量选择
    handleChange(value) {
      this.companyInvoiceCalculatePrice();
      console.log(value);
    },
    //支付密码确认
    handleUnderstandPwd(pwd) {
      if (this.Switch == 1) {
        var data = {
          data: {
            businessType: "PROXY_INVOICE",
            password: pwd,
            businessInfo: {
              customerBankName: this.from.PurchaseBankName,
              customerBankAccount: this.from.PurchaseAccount,
              customerName: this.from.Purchaser, //客户名
              customerLegalPerson: this.from.PurchaserName, //客户法人
              customerCreditCode: this.from.PurchaserCode, //客户统一代码
              customerPhone: this.from.PurchaserPhone, //客户手机号
              customerCompanyType: this.from.customerCompanyType,
              customerCompanyAddress: this.from.PurchaseAddress, //客戶地址
              showCustomerInfo: this.from.PurchaseShowHide, //是否展示购买方信息
              sellerTaxType: this.from.PayTaxesType, //销售方纳税类型
              sellerCompanyType: this.from.EnterpriseType, //销售方企业类型
              sellerBankName: this.from.bank, //销售方开户行名称
              sellerBankAccount: this.from.AccountNumber, //销售方开户行账号
              sellerCompanyAddress: this.from.address, //销售方住所
              sellerPhone: this.from.phone, //销售方手机号
              showSellerInfo: this.from.SalesShowHide, //是否展示销售放信息
              invoiceItemDtoList: [
                {
                  invoiceQuantity: this.from.quantity, //发票数量
                  invoiceAttr: this.from.nature, //发票类型 0普票1专票
                  businessInfo: this.from.Message, //服务信息
                  invoiceFormat: this.from.format, //发票格式
                  sendType: this.from.SendingMode, //发送方式
                  mail: this.from.mailbox, //邮箱
                  remark: this.from.Note, //备注
                },
              ],
              price: this.from.numBean,
            },
            payMethod: "INVOICE_BEANS_PAY",
          },
        };
        pay(data).then((res) => {
          if (res.code == 0) {
            this.VisiblePwd = false;
            this.$tool.PromptBox("success", "操作成功");
            this.$emit("handleVerifyIssue");
          } else {
            this.VisiblePwd = false;
            this.$tool.recordIntentCustomer(3);
          }
        });
      } else {
        // 开给自然人
        var data = {
          data: {
            businessType: "PROXY_PERSON_INVOICE",
            payMethod: "INVOICE_BEANS_PAY",
            password: pwd,
            businessInfo: {
              sellerTaxType: this.from.PayTaxesType, //销售方纳税类型
              sellerCompanyType: this.from.EnterpriseType, //销售方企业类型
              sellerBankName: this.from.bank, //销售方开户行名称
              sellerBankAccount: this.from.AccountNumber, //销售方开户行账号
              sellerCompanyAddress: this.from.address, //销售方住所
              sellerPhone: this.from.phone, //销售方手机号
              showSellerInfo: this.from.SalesShowHide, //是否展示销售放信息
              price: this.from.numBean, //总价格
              invoiceItemDtoList: [
                {
                  invoiceQuantity: this.from.quantity, //发票数量
                  invoiceAttr: this.from.nature, //发票类型 0普票1专票
                  businessInfo: this.from.Message, //服务信息
                  invoiceFormat: this.from.format, //发票格式
                  sendType: this.from.SendingMode, //发送方式
                  mail: this.from.mailbox, //邮箱
                  remark: this.from.Note, //备注
                  customerName: this.from.Purchaser, //姓名
                  customerCreditCode: this.from.PurchaserCode, //身份证号
                  customerPhone: this.from.PurchaserPhone, //手机号
                  customerBankName: this.from.PurchaseBankName, //开户行
                  customerBankAccount: this.from.PurchaseAccount, //账户
                  customerCompanyAddress: this.from.PurchaseAddress, //地址
                  showCustomerInfo: this.from.PurchaseShowHide, //是否展示购买方信息
                },
              ],
            },
          },
        };
        pay(data).then((res) => {
          if (res.code == 0) {
            this.VisiblePwd = false;
            this.$tool.PromptBox("success", "操作成功");
            this.$emit("handleVerifyIssue");
          } else {
            this.VisiblePwd = false;
            this.$tool.recordIntentCustomer(0, 4);
          }
        });
      }
    },
    //确认
    handleVerifyIssue() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (localStorage.getItem("PaymentPwd") == "false") {
            //没有开启支付密码验证直接弹支付二维码
            this.handleUnderstandPwd();
          } else {
            // 支付密码验证
            this.VisiblePwd = true;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      // this.$emit("handleVerifyIssue", this.type);
    },
  },
};
</script>

<style scoped lang="less">
@import "../../Enterprise/Bookkeeping/components/bookkeeping-form-dialog.less";

.Select-Con {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  margin: 0 0 24px;
  border-bottom: 1px solid #edeff2;
  .Options {
    min-width: 96px;
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    margin: 0 24px;
    background: transparent;
    border: none;
    border-radius: 0;
    font-size: 14px;
    color: #666666;
    text-align: center;
    cursor: pointer;
    box-sizing: border-box;
  }
  .Select {
    color: #409eff;
    background: transparent;
    border-bottom: 2px solid #409eff;
  }
}

.main-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;

  .section-row {
    display: flex;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;
  }
  .section-block {
    box-sizing: border-box;
    min-width: 0;
  }
  .section-buyer,
  .section-seller {
    flex: 1 1 0;
    width: 0;
    max-width: 50%;
  }
  .section-buyer {
    padding-right: 24px;
  }
  .section-seller {
    padding-left: 24px;
    border-left: 1px solid #edeff2;
  }
  .section-service {
    margin-top: 8px;
    padding-top: 20px;
    border-top: 1px solid #edeff2;
  }
  .invoice-meta-row {
    display: flex;
    align-items: flex-start;
    flex-wrap: nowrap;
    width: 100%;
    margin-bottom: 2px;
    gap: 32px;
  }
  .section-title {
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    line-height: 22px;
    text-align: center;
  }
  .Reminder {
    width: 100%;
    margin-top: 6px;
    color: #999999;
    font-size: 12px;
    line-height: 18px;
  }
  .quantity-text {
    color: #303133;
    font-size: 14px;
  }
  .consume-text {
    color: #fe574a;
    font-size: 14px;
    line-height: 36px;
  }
  .mailbox {
    width: 360px !important;
    max-width: 100% !important;
  }
}

.invoice-info-form {
  /deep/ .el-form-item {
    margin-bottom: 5px !important;
    display: flex;
    align-items: flex-start;
    width: 100%;
    box-sizing: border-box;
  }
  /deep/ .el-form-item__label {
    white-space: nowrap !important;
    padding-right: 8px !important;
    float: none !important;
    width: auto !important;
    flex: 0 0 148px;
    text-align: right;
    line-height: 36px !important;
  }
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
    line-height: 36px;
    width: auto !important;
    flex: 1 1 auto !important;
    min-width: 0;
    position: relative;
    padding-bottom: 20px;
  }
  /deep/ .el-form-item__error {
    position: absolute !important;
    top: auto !important;
    left: 0 !important;
    bottom: 2px !important;
    margin-top: 0 !important;
    padding-top: 0 !important;
    line-height: 16px;
    z-index: 2;
  }
  /deep/ .el-textarea ~ .el-form-item__error {
    position: absolute !important;
    top: auto !important;
    left: 0 !important;
    bottom: 2px !important;
    margin-top: 0 !important;
    line-height: 16px;
  }
  /deep/ .Instruction .el-form-item__error {
    margin-top: 0 !important;
  }
  /deep/ .el-form-item.is-error .el-input__inner,
  /deep/ .el-form-item.is-error textarea {
    border-color: #fe574a !important;
  }
  /deep/ .el-input,
  /deep/ .el-select {
    width: 360px !important;
    max-width: 100% !important;
    height: 36px !important;
  }
  /deep/ .el-input .el-input__inner,
  /deep/ .el-select .el-input__inner {
    width: 100% !important;
    height: 36px !important;
    line-height: 36px !important;
  }
  /deep/ .el-select .el-input__icon {
    line-height: 36px !important;
  }
  /deep/ .el-textarea {
    width: 360px !important;
    max-width: 100% !important;
  }
  /deep/ .textarea-lg {
    width: 900px !important;
    max-width: 100% !important;
  }
  /deep/ .textarea-lg .el-textarea__inner {
    min-height: 120px !important;
    height: 120px !important;
    line-height: 22px !important;
    padding: 10px 12px !important;
  }
  /deep/ .el-input.is-disabled .el-input__inner {
    background: #ffffff !important;
    color: #606266 !important;
    -webkit-text-fill-color: #606266 !important;
    border-color: #409eff !important;
    cursor: not-allowed !important;
    opacity: 1 !important;
  }
  /deep/ .el-radio-group {
    display: inline-flex;
    flex-wrap: nowrap;
    white-space: nowrap;
    vertical-align: middle;
    max-width: 100%;
    line-height: 36px;
  }
  /deep/ .el-radio {
    margin-right: 10px;
    margin-bottom: 0;
    line-height: 22px;
    white-space: nowrap;
  }
  /deep/ .el-radio__label {
    font-size: 13px;
    color: #333333;
    padding-left: 4px;
  }

  .invoice-meta-row {
    /deep/ .el-form-item {
      margin-bottom: 5px !important;
      margin-right: 28px;
      width: auto;
      flex: 0 0 auto;
    }
    /deep/ .el-form-item__label {
      flex: 0 0 auto;
      width: auto !important;
      padding-right: 6px !important;
    }
    /deep/ .meta-quantity .el-form-item__label,
    /deep/ .meta-send .el-form-item__label {
      flex: 0 0 148px;
    }
    /deep/ .el-form-item__content {
      flex: 0 0 auto;
      margin-right: 24px;
      padding-bottom: 20px;
    }
    /deep/ .el-radio {
      margin-right: 12px;
    }
  }
}
</style>
